import { Ifilter } from "../../../Interfaces/filter";
import { fetchAdministracion } from "../../http-common";

const comboEquipoTrabajoRol = (request: Ifilter, controller = new AbortController()) => {
    return fetchAdministracion.get(`EquipoTrabajoRol/Combo`,
    {
        signal: controller.signal,
        params: request,   
    }
  );
};

const EquipoTrabajoRolService = {
  comboEquipoTrabajoRol,
};

export default EquipoTrabajoRolService;